import { dispatchAction } from '@ardoq/rxbeach';
import { ChevronIcon } from '@ardoq/icons';
import styled from 'styled-components';
import { selectComponent } from 'streams/components/ComponentActions';
import { fontSizeDefinitions_DEPRECATED } from '../../atomicComponents/fonts/fontSizeDefinitionsWithDefaultFont';
import { horizontalSpacing } from 'tabview/pagesView/constants';
import { switchToWorkspace } from 'streams/context/ContextActions';
import { colors } from '@ardoq/design-tokens';
import { COMPONENT_ID_ATTRIBUTE } from '@ardoq/global-consts';
import { truncateComponentLabel } from '@ardoq/graph';
import { returnZero } from '@ardoq/common-helpers';
import type { ComponentPathData } from 'tabview/pagesView/types';

const SmallLayout = styled.div`
  display: flex;
  padding-left: ${horizontalSpacing.SMALL};
  div {
    ${fontSizeDefinitions_DEPRECATED.EXTRA_SMALL}
    color: ${colors.grey950};
    display: flex;
    align-items: center;
  }
`;

const Layout = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  div {
    color: ${colors.grey950};
    display: flex;
  }
`;

const SmallChevron = styled(ChevronIcon)`
  height: 12px;
  margin: 0 2px 0 2px;
`;
const ClickableName = styled.div`
  overflow-wrap: anywhere;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

type ComponentPathProps = ComponentPathData & {
  small: boolean;
};

export const ComponentPath = ({
  path,
  workspace,
  small,
}: ComponentPathProps) => {
  const LayoutComponent = small ? SmallLayout : Layout;
  const Chevron = small ? SmallChevron : ChevronIcon;

  return (
    <LayoutComponent>
      <ClickableName
        onClick={() =>
          dispatchAction(switchToWorkspace({ workspaceId: workspace._id }))
        }
      >
        {workspace.name}
      </ClickableName>
      {path.map(({ _id, name, label }, i) => (
        <div key={`${_id}--${i}`}>
          <Chevron
            direction="right"
            style={small ? { fontSize: '12px' } : {}}
          />
          <ClickableName
            className="component"
            onClick={() => dispatchAction(selectComponent({ cid: _id }))}
            {...{ [COMPONENT_ID_ATTRIBUTE]: _id }}
          >
            {small
              ? name
              : truncateComponentLabel({
                  ...label,
                  measure: returnZero,
                  width: Infinity,
                })}
          </ClickableName>
        </div>
      ))}
    </LayoutComponent>
  );
};
